import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import DatePicker from "@cloudscape-design/components/date-picker";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
	promoBannersAddModalStore,
	tournamentsBannersAddModalStore,
} from "../stores/promoBannersAddModal";
import { MAX_BANNER_BYTES } from "../stores/bannersAddModal";
import { bannersStore, BannersStore } from "../stores/banners";
import DateRangePicker from "@cloudscape-design/components/date-range-picker";
import { promoBannersStore, tournamentsBannersStore } from "../stores/promoBanners";

const isValidBannerFileSize = (file) => Boolean(file) && file.size <= MAX_BANNER_BYTES;

class PromoBannersAddModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		}
	}
	componentDidUpdate(prevProps) {
		if (!prevProps.promoBannersAddModal.show && this.props.promoBannersAddModal.show) {
			this.resetFormFields();
		}
	}

	addBanner() {
		this.setState({
			loading: true
		});
		const body = {
			name: { text: this.props.promoBannersAddModal.name, type: this.props.promoBannersAddModal.nameType.value },
			description: this.props.promoBannersAddModal.descriptionPrefix !== "" ? { type: this.props.promoBannersAddModal.descriptionType.value, prefix: this.props.promoBannersAddModal.descriptionPrefix, text: this.props.promoBannersAddModal.description  } : { type: this.props.promoBannersAddModal.descriptionType.value, text: this.props.promoBannersAddModal.description  },
			image: this.props.promoBannersAddModal.image,
			limit: this.props.promoBannersAddModal.limit > 0 ? this.props.promoBannersAddModal.limit : false,
			minDeposit: this.props.promoBannersAddModal.minDeposit,
			wager: this.props.promoBannersAddModal.wager,
			gameID: this.props.promoBannersAddModal.gameID > 0 ? this.props.promoBannersAddModal.gameID : false,
			date: Math.floor(new Date(this.props.promoBannersAddModal.from).getTime() / 1000)
		};
		this.props.Interface.request("set", {
			class: "data",
			module: "promoBanners",
			method: "add"
		}, { ...body }).then((result) => {
			this.setState({
				loading: false
			});
			this.props.Interface.addNoty("Success", "Promo banner was successfully added");
			this.props.setPromoBannersAddModal({ ...this.props.promoBannersAddModal, show: false });
			this.props.Interface.loadPromoBannerList();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setPromoBanners({ ...this.props.promoBanners, loaded: true, error });

			this.setState({
				loading: false
			});

		})
	}

	resetFormFields = () => {
		this.props.setPromoBannersAddModal({
			...this.props.promoBannersAddModal,
			type: "",
			name: "",
			description: "",
			descriptionType: "",
			descriptionPrefix: "",
			gameID: "",
			minDeposit: "",
			limit: "",
			wager: "",
			date: "",
			image: "",
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateParam = (key, value) => {
		const updatedState = cloneDeep(this.props.promoBannersAddModal);
		updatedState[key] = value;
		this.props.setPromoBannersAddModal(updatedState);
	};

	render() {
		const { promoBannersAddModal, setPromoBannersAddModal } = this.props;
		return (
			<Modal
				visible={promoBannersAddModal.show}
				onDismiss={() =>
					setPromoBannersAddModal({ ...promoBannersAddModal, show: false })
				}
				header="Add promo banner"
				children={
					<SpaceBetween direction="vertical" size="m">
						<Box variant="span">Name Type</Box>
						<Select
							filteringType="auto"
							placeholder="Select name type"
							selectedOption={promoBannersAddModal.nameType}
							onChange={(option) =>
								this.updateParam("nameType", option.detail.selectedOption)
							}
							options={promoBannersAddModal.currentOption.nameType}
						/>
						<Box variant="span">Name</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Name"
							value={promoBannersAddModal.name}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									name: event.detail.value,
								})
							}
						/>
						<Box variant="span">Description Type</Box>
						<Select
							filteringType="auto"
							placeholder="Select title type"
							selectedOption={promoBannersAddModal.descriptionType}
							onChange={(option) =>
								this.updateParam("descriptionType", option.detail.selectedOption)
							}
							options={promoBannersAddModal.currentOption.descriptionType}
						/>
						<Box variant="span">Description Text</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Description text"
							value={promoBannersAddModal.description}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									description: event.detail.value,
								})
							}
						/>
						<Box variant="span">Description prefix</Box>
						<Input
							name="DescriptionPrefix"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Description prefox"
							value={promoBannersAddModal.descriptionPrefix}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									descriptionPrefix: event.detail.value,
								})
							}
						/>
						<Box variant="span">Image</Box>
						<input
							type="file"
							accept="image/jpg"
							onChange={(event) => {
								const file = event.target.files[0];
								if (file) {
									if (!isValidBannerFileSize(file)) {
										this.props.Interface.addNoty("Error", `Image size must not exceed ${MAX_BANNER_BYTES / 1024 / 1024} MB`);
										event.target.value = "";

										return;
									}

									const reader = new FileReader();
									reader.onload = (event) => {
										const result = event.target.result;
										this.updateParam("image", result);
									};
									reader.readAsDataURL(file);
								} else {
									this.props.Interface.addNoty("Error", "Please, select a valid image file");
								}
							}}
						/>
						<Box variant="span">GameID</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="number"
							type="number"
							disableBrowserAutocorrect={true}
							placeholder="GameID"
							value={promoBannersAddModal.gameID}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									gameID: event.detail.value,
								})
							}
						/>
						<Box variant="span">Limit</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="number"
							type="number"
							disableBrowserAutocorrect={true}
							placeholder="Limit"
							value={promoBannersAddModal.limit}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									limit: event.detail.value,
								})
							}
						/>
						<Box variant="span">Min deposit</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="number"
							type="number"
							disableBrowserAutocorrect={true}
							placeholder="Min deposit"
							value={promoBannersAddModal.minDeposit}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									minDeposit: event.detail.value,
								})
							}
						/>
						<Box variant="span">Wager</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="number"
							type="number"
							disableBrowserAutocorrect={true}
							placeholder="Wager"
							value={promoBannersAddModal.wager}
							onChange={(event) =>
								setPromoBannersAddModal({
									...promoBannersAddModal,
									wager: event.detail.value,
								})
							}
						/>
						<Box variant="span">Date</Box>
						<DateRangePicker
							onChange={({ detail }) => {
								setPromoBannersAddModal({
									...promoBannersAddModal,
									from: detail.value.startDate.split("+")[0],
									to: detail.value.endDate.split("+")[0],
									type: detail.value.type
								});
							}}
							value={{
								startDate: promoBannersAddModal.from,
								endDate: promoBannersAddModal.to,
								type: "absolute",
							}}
							relativeOptions={[]}
							isValidRange={range => {
								if (range.type === "absolute") {
									const [
										startDateWithoutTime
									] = range.startDate.split("T");
									const [
										endDateWithoutTime
									] = range.endDate.split("T");
									if (
										!startDateWithoutTime ||
										!endDateWithoutTime
									) {
										return {
											valid: false,
											errorMessage:
												"The selected date range is incomplete. Select a start and end date for the date range."
										};
									}
									if (
										new Date(range.startDate) -
										new Date(range.endDate) >
										0
									) {
										return {
											valid: false,
											errorMessage:
												"The selected date range is invalid. The start date must be before the end date."
										};
									}
								} else {
									return { valid: false}
								}
							}}
							i18nStrings={{
								todayAriaLabel: "Today",
								nextMonthAriaLabel: "Next month",
								previousMonthAriaLabel: "Previous month",
								customRelativeRangeDurationLabel: "Duration",
								customRelativeRangeDurationPlaceholder: "Enter duration",
								customRelativeRangeOptionLabel: "Custom range",
								customRelativeRangeOptionDescription: "Define a custom range in the past",
								customRelativeRangeUnitLabel: "Unit of time",
								formatRelativeRange: ({ amount, unit, startDate, endDate }) => {
									const start = new Date(startDate);
									const end = new Date(endDate);

									const locale = 'en-GB';
									const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
									const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };

									const formattedStart = start.toLocaleDateString(locale, dateOptions) + ' ' + start.toLocaleTimeString(locale, timeOptions);
									const formattedEnd = end.toLocaleDateString(locale, dateOptions) + ' ' + end.toLocaleTimeString(locale, timeOptions);

									return `${formattedStart} - ${formattedEnd}`;
								},
								formatUnit: (unit, amount) => `${unit}${amount > 1 ? 's' : ''}`,
								dateTimeConstraintText: "Date and time must be within the selected range.",
								renderSelectedAbsoluteRangeAriaLive: (startDate, endDate) => `Selected from ${startDate} to ${endDate}`,
								labelRelativeRange: "Relative range",
								labelAbsoluteRange: "Absolute range",
								dateTimePickerAriaLabel: "Date and time picker",
								dateTimePickerLabel: "Date and Time",
								clearButtonAriaLabel: "Clear date range",
								relativeModeTitle: "Relative mode",
								absoluteModeTitle: "Absolute mode",
								cancelButtonLabel: "Cancel",
								applyButtonLabel: "Apply",
							}}
							placeholder="Only from"
						/>
					</SpaceBetween>
				}
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button
								variant="normal"
								onClick={() =>
									setPromoBannersAddModal({ ...promoBannersAddModal, show: false })
								}
								children="Close"
							/>
							<Button
								variant="primary"
								disabled={this.state.loading}
								onClick={() => this.addBanner()}
								children="Ok"
							/>
						</SpaceBetween>
					</Box>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promoBannersAddModal = useRecoilValue(promoBannersAddModalStore);
		const setPromoBannersAddModal = useSetRecoilState(promoBannersAddModalStore);
		const promoBanners = useRecoilValue(promoBannersStore);
		const setPromoBanners = useSetRecoilState(promoBannersStore);
		return (
			<Component
				{...props}
				promoBanners={promoBanners}
				setPromoBanners={setPromoBanners}
				setPromoBannersAddModal={setPromoBannersAddModal}
				promoBannersAddModal={promoBannersAddModal}
			/>
		);
	};
}

export default withRecoil(PromoBannersAddModal);
